import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Dialog from "../../base_component/Dialog/Dialog";
import { X } from "lucide-react";
import ArtworkActive from "../../assets/images/Frame.svg"
import ArtworkInActive from "../../assets/images/Frame (1).svg"
import MessageActive from "../../assets/images/Frame (2).svg"
import MessageInActive from "../../assets/images/Frame (3).svg"
import BillingActive from "../../assets/images/Frame (4).svg"
import BillingInActive from "../../assets/images/Frame (5).svg"
import ProfileActive from "../../assets/images/Frame (7).svg"
import ProfileInActive from "../../assets/images/Frame (6).svg"
import { IoLogOut } from "react-icons/io5";
import EllipsisLoader from "../../base_component/EllipsisLoader/EllipsisLoader";
import { logoutAPI } from "../../service/ApiServices";
import toast from "react-hot-toast";
import { useRoomManager } from "../../components/RoomManager";
import { Socket } from "../../Socket/Socket";

const SideMenu = ({ sidebarOpen, setSidebarOpen }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isLogOut, setIsLogOut] = useState(false);
  const { leaveRoom } = useRoomManager();
  const [planStatus, setPlanStatus] = useState(localStorage.getItem("plan"));
  const [isLogoutLoading, setIsLogoutLoading] = useState(false);
  const trigger = useRef(null);
  const sidebar = useRef(null);

  const storedSidebarExpanded = localStorage.getItem("sidebar-expanded");
  const [sidebarExpanded, setSidebarExpanded] = useState(
    storedSidebarExpanded === null ? false : storedSidebarExpanded === "true"
  );

  useEffect(() => {
    const handleStorageChange = () => {
      setPlanStatus(localStorage.getItem("plan"));
    };
    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('planStatusChanged', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('planStatusChanged', handleStorageChange);
    };
  }, []);

  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!sidebar.current || !trigger.current) return;
      if (
        !sidebarOpen ||
        sidebar.current.contains(target) ||
        trigger.current.contains(target)
      )
        return;
      setSidebarOpen(false);
    };
    document.addEventListener("click", clickHandler);
    return () => document.removeEventListener("click", clickHandler);
  });

  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!sidebarOpen || keyCode !== 27) return;
      setSidebarOpen(false);
    };
    document.addEventListener("keydown", keyHandler);
    return () => document.removeEventListener("keydown", keyHandler);
  });

  useEffect(() => {
    localStorage.setItem("sidebar-expanded", sidebarExpanded.toString());
    if (sidebarExpanded) {
      document.querySelector("body")?.classList.add("sidebar-expanded");
    } else {
      document.querySelector("body")?.classList.remove("sidebar-expanded");
    }
  }, [sidebarExpanded]);

  const handleNavigation = (path) => {
    if (location.pathname === "/messages" && path !== "/messages") {
      leaveRoom();
    }
    setSidebarOpen(!sidebarOpen);
  };

  const handleGoLiveNavigation = () => {
    if (location.pathname === "/messages") {
      leaveRoom();
    }
    navigate("/subscription_plan");
    setSidebarOpen(false);
  };

  const handleNavigate = () => {
    leaveRoom();
    setIsLogoutLoading(true);
    logoutAPI({
      device_id: localStorage.getItem("deviceIdHoast")
    })
      .then((res) => {
        localStorage.removeItem('hoast_token')
        localStorage.removeItem('hoast_refresh_token')
        navigate("/login");
        setIsLogoutLoading(false);
        Socket.disconnect();
        toast.success(res?.data?.message);
      })
      .catch((err) => {
        setIsLogoutLoading(false);
        const status = err.response?.status;
        toast.success(err?.response?.data?.message);
        if (status === 401) {
          localStorage.removeItem('hoast_token')
          localStorage.removeItem('hoast_refresh_token')
          Socket.disconnect();
          navigate("/login");
        }
        Socket.disconnect();
        setIsLogoutLoading(false);
      });
  };

  let artwork = location.pathname.includes("/artwork_list") || location.pathname.includes("/all_set_page")
  let billing = location.pathname.includes("/billing") || location.pathname.includes("/invoice")
  let profile = location.pathname.includes("/profile") || location.pathname.includes("/subscription_plan")

  return (
    <>
      <aside
        ref={sidebar}
        className={`absolute left-0 top-0 bg-[#1E1E1E] min-h-screen z-99 w-full flex h-screen sm:w-80 flex-col overflow-y-hidden duration-300 ease-linear dark:bg-boxdark 2xl:static xl:static lg:static 2xl:translate-x-0 xl:translate-x-0 lg:translate-x-0 ${sidebarOpen ? "translate-x-0" : "-translate-x-full"
          }`}
      >
        <div className="absolute end-2 top-5 2xl:hidden lg:hidden ac">
          <button ref={trigger} onClick={() => setSidebarOpen(!sidebarOpen)}>
            <X className="text-white cursor-pointer rotate-1" />
          </button>
        </div>

        <div onClick={() => navigate("/artwork_list")} className="flex select-none items-center text-4xl text-white py-4 justify-center border-[#383E49] border-b-2 cursor-pointer">
          HOAST
        </div>

        <div className="no-scrollbar flex flex-col justify-between overflow-y-auto duration-300 ease-linear h-screen py-2">
          <div className="flex justify-start items-stretch">
            <div className="w-full relative h-[calc(100vh-130px)]">
              <Link
                to={"/profile"}
                onClick={() => handleNavigation("/profile")}
              >
                <span
                  className={
                    profile
                      ? "flex items-center bg-gradient-to-r from-[#F48B94] to-[#F48B9400] p-4 justify-start my-4"
                      : "my-4 flex items-center p-4 transition duration-300 ease-in-out hover:opacity-100"
                  }
                >
                  <img
                    src={profile ? ProfileActive : ProfileInActive}
                    className="w-6 mx-2"
                    alt=""
                  />
                  <p
                    className={
                      profile
                        ? "text-[#fff] font-medium"
                        : "text-[#8C8C8C] font-medium"
                    }
                  >
                    Profile
                  </p>
                </span>
              </Link>

              <Link
                to={"/artwork_list"}
                onClick={() => handleNavigation("/artwork_list")}
              >
                <span
                  className={
                    artwork
                      ? "flex items-center bg-gradient-to-r from-[#F48B94] to-[#F48B9400] p-4 justify-start my-4"
                      : "my-4 flex items-center p-4 transition duration-300 ease-in-out hover:opacity-100"
                  }
                >
                  <img
                    src={artwork ? ArtworkActive : ArtworkInActive}
                    className="w-6 mx-2"
                    alt=""
                  />
                  <p
                    className={
                      artwork
                        ? "text-[#fff] font-medium"
                        : "text-[#8C8C8C] font-medium"
                    }
                  >
                    Artwork
                  </p>
                </span>
              </Link>

              <Link
                to={"/messages"}
                onClick={() => handleNavigation("/messages")}
              >
                <span
                  className={
                    location.pathname == "/messages"
                      ? "flex items-center bg-gradient-to-r from-[#F48B94] to-[#F48B9400] p-4 justify-start my-4"
                      : "my-4 flex items-center p-4 transition duration-300 ease-in-out hover:opacity-100"
                  }
                >
                  <img
                    src={location.pathname == "/messages" ? MessageActive : MessageInActive}
                    className="w-6 mx-2"
                    alt=""
                  />
                  <p
                    className={
                      location.pathname == "/messages"
                        ? "text-[#fff] font-medium"
                        : "text-[#8C8C8C] font-medium"
                    }
                  >
                    Messages
                  </p>
                </span>
              </Link>

              <Link
                to={"/billing"}
                onClick={() => handleNavigation("/billing")}
              >
                <span
                  className={
                    billing
                      ? "flex items-center bg-gradient-to-r from-[#F48B94] to-[#F48B9400] p-4 justify-start my-4"
                      : "my-4 flex items-center p-4 transition duration-300 ease-in-out hover:opacity-100"
                  }
                >
                  <img
                    src={billing ? BillingActive : BillingInActive}
                    className="w-6 mx-2"
                    alt=""
                  />
                  <p
                    className={
                      billing
                        ? "text-[#fff] font-medium"
                        : "text-[#8C8C8C] font-medium"
                    }
                  >
                    Billing
                  </p>
                </span>
              </Link>

              {planStatus == "no" &&
                <div className="relative mt-8 mx-6">
                  <div className="relative bg-gradient-to-l from-[#1D64F0] to-[#508BFF] text-white h-fit text-center rounded-2xl">
                    <div className="relative py-6 px-4">
                      <h4 className="text-base md:text-[22px]">
                        Activate Your Artist Profile
                      </h4>
                      <p className="py-4 text-sm">
                        Your profile will be visible to visitors as soon as your subscription is active.
                      </p>
                      <button
                        onClick={handleGoLiveNavigation}
                        className="bg-[#FFFFFF] w-full text-[#112211] px-4 py-3 rounded-lg text-sm font-semibold"
                      >
                        Go Live Now
                      </button>
                    </div>
                  </div>
                </div>
              }

              <div onClick={() => setIsLogOut(true)} className="absolute py-3 w-full cursor-pointer flex gap-2 items-center bottom-0 px-5 text-white">
                <IoLogOut size={24} className="text-gray-400" />
                <span className="-pt-1">Log Out</span>
              </div>
            </div>
          </div>
        </div>

        <Dialog
          open={isLogOut}
          onClose={() => setIsLogOut(false)}
          size="md"
        >
          <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

          <Dialog.Panel>
            <div className='flex justify-end mt-3'>
              <button
                className="bg-[#F4F5FA] text-sm rounded-xl sm:mx-3 mx-2"
                onClick={() => setIsLogOut(false)}
              >
                <X />
              </button>
            </div>

            <Dialog.Description>
              <div className="flex justify-center text-center px-8">
                <div>
                  <h1 className="text-2xl font-semibold text-black">
                    Log Out?
                  </h1>
                  <p className="md:text-base text-sm text-gray-500 my-3">
                    Are you sure you want to log out from your account?
                  </p>
                  <div className="flex items-center my-8 justify-center">
                    <button
                      onClick={handleNavigate}
                      disabled={isLogoutLoading}
                      className="bg-[#EA5F5F] h-[50px] w-full text-sm rounded-xl sm:mx-3 mx-2 text-white disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                    >
                      {isLogoutLoading ? (
                        <EllipsisLoader color="white" />
                      ) : (
                        "Yes, Log Out"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </Dialog.Description>
          </Dialog.Panel>
        </Dialog>
      </aside>
    </>
  );
};

export default SideMenu;
